module.exports = __webpack_public_path__ + "static/media/web.be8dac0e.png";